import React, {useEffect, useRef, useState} from 'react';
import {useDataValue} from 'globals/contexts/dataContext';

import transitionImage from 'media/transition.png';

import './inkTransition.css';

const InkTransition = () => {
  const [{pageTransition}] = useDataValue();
  const [animating, setIsAnimating] = useState(false);
  const [imgSize, setImgSize] = useState([window.innerWidth, window.innerHeight]);
  const [ctx, setCtx] = useState(null);
  const inkCanvas = useRef(null);
  const inkInvCanvas = useRef(null);
  const canvas = useRef(null);
  const animationFrame = useRef(null);
  const frame = useRef(0);
  const imgW = 2980;
  const imgH = 503;
  const createInkBuff = () => {
    const buffCanvas = document.createElement('canvas');
    const buffInvCanvas = document.createElement('canvas');
    const ctx = buffCanvas.getContext('2d');
    const ctxInv = buffInvCanvas.getContext('2d');
    const img = new Image(imgW, imgH);
    // const newH = Math.ceil(imgH / 3);
    buffCanvas.width = buffInvCanvas.width = imgW * 3;
    buffCanvas.height = buffInvCanvas.height = Math.floor(imgH / 3);
    img.onload = () => {
      ctx.drawImage(img, 0, 0, imgW, imgH / 3, 0, 0, imgW, imgH / 3);
      ctx.drawImage(img, 0, Math.ceil(imgH / 3), imgW, imgH / 3, imgW, 0, imgW, imgH / 3);
      ctx.drawImage(img, 0, 2 * Math.ceil(imgH / 3), imgW, imgH / 3, 2 * imgW, 0, imgW, imgH / 3);
      ctxInv.save();
      ctxInv.rotate(Math.PI);
      ctxInv.drawImage(buffCanvas, -buffInvCanvas.width, -buffInvCanvas.height);
      ctxInv.restore();

      inkCanvas.current = buffCanvas;
      inkInvCanvas.current = buffInvCanvas;
    }
    img.src = transitionImage;
  }
  const onResize = () => {
    const imgScaledW = imgW / 10 ; // / window.innerWidth;
    const imgScaledH = imgH / 3 ; // / window.innerHeight;
    canvas.current.width = window.innerWidth;
    canvas.current.height = window.innerHeight;
    if (imgScaledW / imgScaledH > window.innerWidth / window.innerHeight) {
      setImgSize([
        Math.floor(imgScaledH * window.innerWidth / window.innerHeight), Math.floor(imgScaledH)
      ]);
    } else {
      setImgSize([
        Math.floor(imgScaledW), Math.floor(imgScaledW / window.innerWidth * window.innerHeight)
      ]);
    }
    // setImgSize([
    //   imgScaledW, imgScaledH
    // ]);
  }
  const animate = () => {
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current);
    }
    frame.current = 0;
    animationFrame.current = requestAnimationFrame(animateIn);
  }
  const animateIn = () => {
    setIsAnimating(true);
    if (inkCanvas.current) {
      const currentFrame = frame.current % 31;
      // ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      if (currentFrame < 30) {
        ctx.drawImage(inkCanvas.current, 
          currentFrame * Math.round(imgW / 10) + (imgW / 10 - imgSize[0]) / 2, 0, 
          Math.round(imgSize[0]), Math.round(imgSize[1]), 
          0, 0, window.innerWidth, window.innerHeight
        );
        cancelAnimationFrame(animationFrame.current);
        animationFrame.current = requestAnimationFrame(animateIn);
      } else {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
        frame.current = 0;
        // setTimeout(animateOut, 1000);
      }
      frame.current++;
    }
  }
  const animateOut = () => {
    if (inkCanvas.current) {
      const currentFrame = Math.round( frame.current ) % 31;
      // ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      if (currentFrame < 30) {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        ctx.drawImage(inkInvCanvas.current, currentFrame * Math.round(imgW / 10) + (imgW / 10 - imgSize[0]) / 2, 0, Math.round(imgSize[0]), Math.round(imgSize[1]), 0, 0, window.innerWidth, window.innerHeight);
        cancelAnimationFrame(animationFrame.current);
        animationFrame.current = requestAnimationFrame(animateOut);
      } else if (currentFrame === 30) {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        frame.current = 0;
        setIsAnimating(false);
      }
      frame.current++;
      // if (frame.current % 30 === 0) {
      //   // ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      //   ctx.fillStyle = '#000';
      //   ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
      // }
      // if (frame.current > 59) {
      //   frame.current = frame.current % 60;
      //   ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      // }
    }
    // animationFrame.current = requestAnimationFrame(animate);
    // setTimeout(animate, 1000 / 3);
  }
  useEffect(() => {
    window.addEventListener('resize', onResize);
    createInkBuff();
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);
  useEffect(() => {
    if (canvas.current) {
      const ctx = canvas.current.getContext('2d');
      setCtx(ctx);
      // requestAnimationFrame(animate);
    }
  }, [canvas.current]);
  useEffect(() => {
    if (pageTransition) {
      // console.log('animateIn');
      animateIn();
    } else {
      // console.log('animateOut');
      animateOut();
    }
  }, [pageTransition]);
  return <canvas ref={canvas} className={`transitionCanvas${animating? ' active': ''}`} />;
}

export default InkTransition;